import { Routes } from '@angular/router';
import { LoginComponent } from './features/login/login.component';
import { authGuard } from './core/auth/auth.guard';
import { RegistrationComponent } from './features/competition/registration/registration.component';
import { RegistrationSuccessComponent } from './features/competition/registration-success/registration-success.component';
import { guestGuard } from './core/auth/guest.guard';

export const routes: Routes = [
  { 
    path: 'aguai-2026/login', 
    component: LoginComponent,
    canActivate: [guestGuard]
  },
  {
    path: 'aguai-2026/registration',
    component: RegistrationComponent,
    canActivate: [authGuard]
  },
  {
    path: 'aguai-2026/registration-success',
    component: RegistrationSuccessComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'aguai-2026/login',
  },
];